import Api from 'core/services/api'
import {
  getAllImportsRequest,
  getImportDetailsRequest,
  uploadSpreadsheetRequest,
  downloadImportsRequest,
  cancelImportRequest,
  confirmImportRequest,
} from 'core/services/models'

const path = '/v1/imports'

/**
 * Apresenta as importações realizadas pelo seller identificado pelo cabeçalho X-Tenant-Id.
 * @param int page
 * @param int per_page
 */
export const getAllImports = (params: getAllImportsRequest = {}) => {
  return Api.request({
    url: path,
    params: { ...params },
    method: 'get',
  })
}

/**
 * Exibe informações detalhadas da planilha importada.
 * @param string id
 * @param boolean only_errors
 */
export const getImportDetails = (params: getImportDetailsRequest = {}) => {
  const { id, ...other } = params

  return Api.request({
    url: `${path}/${id}`,
    params: { ...other },
    method: 'get',
  })
}

/**
 * Importa produtos, preços e estoques da planilha padrão do catálogo.
 * @param file
 */
export const uploadSpreadsheet = (data: uploadSpreadsheetRequest) => {
  return Api.request({
    url: path,
    data,
    headers: { 'content-type': 'multipart/form-data' },
    method: 'post',
  })
}

/**
 * Realiza download das importações que foram realizadas usando o query parameter import_id caso esse campo não seja informado será retornado o template.
 * @param string id
 */
export const downloadImports = (params: downloadImportsRequest = {}) => {
  const { id: import_id, ...other } = params

  return Api.request({
    url: `${path}/download`,
    headers: { Accept: 'application/octet-stream' },
    responseType: 'blob',
    params: { import_id, ...other },
    method: 'get',
  })
}

/**
 * Aborta a internalização dos dados carregados na importação da planilha.
 * @param string id
 */
export const cancelImport = (params: cancelImportRequest = {}) => {
  const { id } = params

  return Api.request({
    url: `${path}/${id}/cancel`,
    method: 'put',
  })
}

/**
 * Autoriza a internalização dos dados carregados na importação da planilha excluindo, se houver, as linhas que tiveram problemas de validação.
 * @param string id
 */
export const confirmImport = (params: confirmImportRequest = {}) => {
  const { id } = params

  return Api.request({
    url: `${path}/${id}/confirm`,
    method: 'put',
  })
}

export const hasImportActive = async () => {
  return Api.request({
    url: `${path}/has_active`,
    method: 'get',
  })
}
